$(document).ready(function () {
  // Sticky Header on Scroll
  var header = $("header");
  var headerHeight = header.outerHeight();

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerHeight) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  });

  // Theme Switcher
  $(".themeSwitch").on("click", function () {
    var html = $("html");
    var currentTheme = html.attr("theme");

    if (currentTheme === "dark") {
      html.attr("theme", "light");
    } else {
      html.attr("theme", "dark");
    }
  });
});
